var _path, _circle, _circle2, _path2, _path3, _rect, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg12Etc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5289 32.1864C21.644 31.985 21.8261 31.831 22.0409 31.7438C27.8978 29.367 32.0281 23.6219 32.0281 16.912C32.0281 8.07546 24.8646 0.912018 16.0281 0.912018C7.19152 0.912018 0.0280762 8.07546 0.0280762 16.912C0.0280762 23.708 4.26513 29.5144 10.2417 31.8337C10.463 31.9195 10.6509 32.0759 10.7687 32.282L14.385 38.6106C15.1528 39.9542 17.0902 39.9542 17.8579 38.6106L21.5289 32.1864Z",
    fill: "#5746C0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.0281,
    cy: 16.912,
    r: 13.5,
    fill: "#291F50"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.66,
    cy: 20.6349,
    r: 4.36805,
    fill: "#8F87F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6598 16.2669C10.8738 16.2669 10.1362 16.4745 9.49902 16.8379C10.576 16.5409 13.2195 16.3665 15.1776 18.045C14.3822 16.9665 13.1027 16.2669 11.6598 16.2669Z",
    fill: "#766EDF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29199 20.6346C7.29199 23.047 9.24763 25.0026 11.66 25.0026C12.4707 25.0026 13.2298 24.7818 13.8804 24.397C9.02579 24.1482 8.06424 20.0159 8.19029 17.9808C7.62682 18.7164 7.29199 19.6364 7.29199 20.6346Z",
    fill: "#4841A6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.66064,
    y: 7.44376,
    width: 7.86248,
    height: 7.86248,
    rx: 0.4,
    transform: "rotate(15 9.66064 7.44376)",
    fill: "#E7E6F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14307 9.37527L7.72926 14.6517C7.67208 14.8651 7.79872 15.0844 8.0121 15.1416L14.2853 16.8225C10.7745 15.2141 9.39431 11.1875 9.14307 9.37527Z",
    fill: "#ABA9C8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0281 25.02H23.7985C24.1548 25.02 24.3333 24.5892 24.0813 24.3372L16.7109 16.9668C16.4589 16.7148 16.0281 16.8933 16.0281 17.2496V24.02C16.0281 24.5723 16.4758 25.02 17.0281 25.02Z",
    fill: "#4841A6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0281 17.4843V24.0196C16.0281 24.5719 16.4758 25.0196 17.0281 25.0196H19.9926C16.9291 23.4719 16.0731 19.3512 16.0281 17.4843Z",
    fill: "#353071"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg12Etc);
export default __webpack_public_path__ + "static/media/12_etc.39cfb2b002505b586555d1a1a8a94f0d.svg";
export { ForwardRef as ReactComponent };